import { createRoot } from 'react-dom/client';
import './default.sass';
import IntroPage from '../components/IntroPage/IntroPage';

document.body.innerHTML = '<div id="main"></div>';
document.body.className = 'body';

const root = createRoot(document.getElementById('main'));
root.render(<IntroPage />);